import React from 'react'

import { TabPanel as ChakraTabPanel, TabPanelProps as ChakraTabPanelProps } from '@chakra-ui/react'

const TabPanel = React.forwardRef<HTMLDivElement, ChakraTabPanelProps>((props, ref) => {
    return <ChakraTabPanel ref={ref} padding={0} outline="none" {...props} />
})

export default TabPanel
